module.exports = __webpack_public_path__ + "img/725565a.png";